import $api from "..";
import { AxiosResponse } from "axios";

import { IFeedback } from "../common/api_interfaces/common/IFeedback";
import { IGetOneRole } from "../common/api_interfaces/role/IGetOneRole";
import { IEditRole } from "../common/api_interfaces/role/IEditRole";
import { ICreateRole } from "../common/api_interfaces/role/ICreateRole";
import { IGetRole } from "../common/api_interfaces/role/IGetRole";
import { IDeleteRole } from "../common/api_interfaces/role/IDeleteRole";
import { ISideBar } from "../common/api_interfaces/common/ISideBar";
import { IRestrictBoard } from "../common/api_interfaces/board/IRestrictBoard";
import { IRestrictBoardView } from "../common/api_interfaces/board/IRestrictBoardView";
import { IEditUserStatus } from "../common/api_interfaces/user/IEditUserStatus";
import { ISystemInvitePerson } from "../common/api_interfaces/user/ISystemInvitePerson";
import { ISystemDeletePerson } from "../common/api_interfaces/user/ISystemDeletePerson";
import { FunctionsAccessRequest } from "../common/api_interfaces/role/FunctionsAccessRequest";
import { IFunctionPermissions } from "../common/api_interfaces/role/IFunctionPermissions";
import { IEditElemSettings, IElemSettings } from "../common/api_interfaces/settings/IElemSettings";
import { IGroupFunction } from "../common/api_interfaces/role/IFunctions";
import { IPersonWithRolesToExcludePermissions } from "../common/api_interfaces/role/IRole";
import { IExcludePermission } from "../common/api_interfaces/role/IExcludePermission";

export default class CommonService {
    static async deleteImg(body: { img: string }): Promise<AxiosResponse<any>> {
        return $api.post<any>(`System/deleteImg`, body);
    }

    static async hasPermission(body: FunctionsAccessRequest): Promise<AxiosResponse<IFunctionPermissions[]>> {
        return $api.post<IFunctionPermissions[]>(`hasPermission`, body);
    }

    static async saveRestrict(body: IRestrictBoard): Promise<AxiosResponse<any>> {
        return $api.post<any>(`Board/restrictAccess`, body);
    }

    static async restrictAccess(projectId: number): Promise<AxiosResponse<IRestrictBoardView>> {
        return $api.get<IRestrictBoardView>(`Board/restrictAccess?projectId=${projectId}`);
    }

    static async saveExcludeAccessPermission(body: IExcludePermission): Promise<AxiosResponse<any>> {
        return $api.post<any>(`System/excludePermission`, body);
    }

    static async getDataToExcludePermissions(id: number): Promise<AxiosResponse<IPersonWithRolesToExcludePermissions>> {
        return $api.get<IPersonWithRolesToExcludePermissions>(`System/excludePermission?personId=${id}`);
    }

    async systemInviteUser(body: ISystemInvitePerson): Promise<AxiosResponse<any>> {
        return $api.post<any>(`System/inviteUser`, body);
    }

    static async deleteSystemPerson(body: ISystemDeletePerson[]): Promise<AxiosResponse<any>> {
        return $api.post<any>(`System/deletePerson`, body);
    }

    async editUser(body: IEditUserStatus): Promise<AxiosResponse<any>> {
        return $api.post<any>(`System/editUser`, body);
    }

    static async getAllAvailablePermissions(): Promise<AxiosResponse<IGroupFunction[]>> {
        return $api.get<IGroupFunction[]>(`System/createRole`);
    }

    static async deleteRoles(reqBody: IDeleteRole): Promise<AxiosResponse<any>> {
        return $api.post<{ id: number[] }>(`System/deleteRole`, reqBody);
    }

    static async createRole(reqBody: ICreateRole): Promise<AxiosResponse<any>> {
        return $api.post<ICreateRole>(`System/createRole`, reqBody);
    }

    static async editRole(reqBody: IEditRole): Promise<AxiosResponse<any>> {
        return $api.post<IEditRole>(`System/editRole`, reqBody);
    }

    static async getRole(id: number): Promise<AxiosResponse<IGetOneRole>> {
        return $api.get<IGetOneRole>(`System/getRole?role=${id}`);
    }

    static async getNameAllRoles(): Promise<AxiosResponse<IGetRole[]>> {
        return $api.get<IGetRole[]>(`System/getRoles`);
    }

    static async getAllRoles(): Promise<AxiosResponse<IGetRole[]>> {
        return $api.get<IGetRole[]>(`System/getRoles`);
    }

    static async deleteAllFilesWithoutBind() {
        return $api.get(`/files/deleteTrashFiles`);
    }

    async getSystemCover(): Promise<AxiosResponse<string>> {
        return $api.get<string>(`System/settings/getSystemCover`);
    }

    async getSystemLogo(): Promise<AxiosResponse<string>> {
        return $api.get<string>(`System/settings/getSystemLogo`);
    }

    static async getProjects(): Promise<AxiosResponse<ISideBar>> {
        return $api.get<ISideBar>(`sideBar`);
    }

    static async addFeedback(reqBody: IFeedback): Promise<void> {
        return $api.post(`addFeedback`, reqBody);
    }    

    static async editSystemSettings(reqBody: IEditElemSettings[]): Promise<AxiosResponse<any>> {
        return $api.post(`System/editSettings`, reqBody);
    }

    static async getSystemSettings(): Promise<AxiosResponse<IElemSettings[]>> {
        return $api.get("System/settings");
    }

    static async getPublicSettigns(): Promise<AxiosResponse<IElemSettings[]>> {
        return $api.get("/System/getPublicSettings");
    }

    static async getVersion() {
        return $api.get("/System/getVersion");
    }
}
